module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fourzefour-logo",
    attrs: {
      "id": "helpPage"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/help.jpg"),
      "alt": "帮助中心"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.companyLists), function(item) {
    return _c('ul', [_c('li', [_vm._v(_vm._s(item))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-6f6aa0e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/helpPage.vue
// module id = 1709
// module chunks = 0